// helpers/pwaInstallHelper.ts
let deferredPrompt: any = null;

export function initPWAInstall() {
  if (typeof window === 'undefined') return;

  window.addEventListener('beforeinstallprompt', (e: any) => {
    e.preventDefault();
    deferredPrompt = e;
  });
}

export async function triggerPWAInstall(): Promise<
  'accepted' | 'dismissed' | null
> {
  if (!deferredPrompt) return null;

  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  deferredPrompt = null;

  return outcome; // "accepted" | "dismissed"
}

export function canTriggerPWAInstall(): boolean {
  return !!deferredPrompt;
}
